import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import TabsCartSidebar from '../../components/tabs/TabsCartSidebar'
import { hasCartItems } from '../../selectors/cart'
import { makeGetTabOrder } from '../../selectors/order'
import { startTabOrderAdjustment } from '../../actions/order'

const mapStateToProps = (state, ownProps) => {
  const orderId = get(ownProps, 'match.params.orderId', undefined)
  const isNewOrder = orderId === undefined || orderId === 'pay-now'
  const getTabOrder = makeGetTabOrder(orderId)

  return {
    hasCartItems: hasCartItems(state),
    order: getTabOrder(state, orderId),
    isNewOrder,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = get(ownProps, 'match.params.orderId', undefined)
  const isNewOrder = orderId === undefined || orderId === 'pay-now'
  const replace = get(ownProps, 'history.replace', () => {})

  return {
    onTopButtonTap: () => {
      if (isNewOrder) return

      dispatch(startTabOrderAdjustment(orderId, 'add', { calculateRemoteOrderTotal: true }))
      replace('/tabs')
    },
    onBottomButtonTap: () => {
      if (isNewOrder) {
        replace('/tab-order/pay-now')
      } else {
        replace(`/tab-order/${orderId}/pay-now`)
      }
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TabsCartSidebar))
